// run-toc — default skin module
// Token disposition: pass-through (no overrides)
// NO external imports — plain JavaScript only

export const styles = `
  :host {
    display: block;
    width: var(--run-toc-width, 220px);
  }

  run-box[part="container"] {
    display: flex;
    flex-direction: column;
    gap: var(--run-toc-gap, var(--run-space-semantic-xs));
  }

  [part="entry"] {
    position: relative;
    display: flex;
    align-items: center;
  }

  [part="entry"][data-level="3"] {
    padding-inline-start: var(--run-toc-indent-level-3, var(--run-space-semantic-sm));
  }

  [part="entry"][data-level="4"] {
    padding-inline-start: var(--run-toc-indent-level-4, var(--run-space-semantic-md));
  }

  [part="entry"][data-active]::before {
    content: '';
    position: absolute;
    inset-inline-start: 0;
    top: 0;
    bottom: 0;
    width: var(--run-toc-active-indicator-width, 2px);
    background: var(--run-toc-active-indicator-color, var(--run-color-intent-primary-base));
  }

  [part="entry"][data-active] run-link {
    color: var(--run-toc-active-color, var(--run-color-intent-primary-base));
    background: var(--run-toc-active-bg, var(--run-color-surface-subtle));
  }
`;

export function render(host) {
  const { sections, resolvedMode, activeAnchor } = host;

  if (!sections || sections.length === 0) {
    host.shadowRoot.innerHTML = '';
    return;
  }

  if (resolvedMode === 'dropdown') {
    const options = sections.map(({ anchor, heading }) =>
      `<option value="${anchor}">${heading}</option>`
    ).join('');
    host.shadowRoot.innerHTML = `
      <run-select part="select" aria-label="Table of contents" value="${activeAnchor}">
        ${options}
      </run-select>
    `;
    return;
  }

  // list mode
  const items = sections.map(({ anchor, heading, level }) => {
    const isActive = anchor === activeAnchor;
    const activeAttr = isActive ? ' data-active' : '';
    const ariaCurrent = isActive ? ' aria-current="location"' : '';
    return `<div part="entry" data-level="${level}"${activeAttr} role="listitem">
        <run-link href="#${anchor}"${ariaCurrent}>${heading}</run-link>
      </div>`;
  }).join('');

  host.shadowRoot.innerHTML = `
    <run-box part="container">
      ${items}
    </run-box>
  `;
}